export interface Group {
    id: string,
    name: string,
    type: string
}

export interface SpaceSearchResult {
    id: number,
    key: string,
    name: string,
    type: string,
}

export interface SpaceSearchResponse {
    results: SpaceSearchResult[],
    start: number,
    limit: number,
    size: number,
    _links: {
        next: string,
    },
}

export interface PageSearchResponse {
    results: PageSearchResult[],
    start: number,
    limit: number,
    size: number,
    _links: {
        next: string,
    },
    next?: string,
}

export interface PageSearchResult {
    id: string;
    title: string;
    spaceName: string;
    link: string;
}

export interface BearerToken {
    token: string,
    expiresAt: number,
}

export interface BearerTokenStore {
    get: (key: string) => Promise<BearerToken | null>;
    set: (key: string, value: BearerToken) => Promise<void>;
}

export interface AtlassianLocation {
    target: string;
    context: AtlassianLocationContext;
    href: string;
}

export interface AtlassianLocationContext {
    addonKey: string;
    moduleKey: string;
}

export interface AtlassianUser {
    type: string;
    accountId: string;
    accountType: string;
    email: string;
    publicName: string;
    displayName: string;
    operations: Operation[];
}

export interface Operation {
    operation: "administer" | "use";
    targetType: "application" | "space";
}

export interface LabelSearchResult {
    results: Label[];
}

export interface Label {
    id: string,
    name: string,
    prefix: LabelPrefix,
}

export enum LabelPrefix {
    Global = "global",
    My = "my",
    Team = "team",
}

export const LabelSearchAPILimit = 250;
